import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';

export default function LoanAgeingReport() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [groupId, setGroupId] = useState("");
  const [columns, setColumns] = useState([]);

  const fetchData = async () => {
    if (!groupId || !dateFrom || !dateTo) {
      alert("Please select Group ID, Date From, and Date To");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_PATH}loan/loan_age_sp?groupid=${groupId}&datefrom=${dateFrom.toISOString()}&dateto=${dateTo.toISOString()}`
      );
      const data = await response.json();

      if (data && Array.isArray(data)) {
        setRecords(data);

        // Build dynamic columns based on keys
        if (data.length > 0) {
          const keys = Object.keys(data[0]);
          const cols = keys.map((key) => ({
            field: key,
            header: key.toUpperCase(),
          }));
          setColumns(cols);
        }
      }
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const dateTemplate = (date) =>
    date ? date.toLocaleDateString("en-GB") : "";

  return (
    <div className="p-4">
      <Card title="Loan Ageing Report" className="shadow-md">
        <div className="grid gap-4 mb-4">

          <div className="col-12 md:col-3">
            <label className="block mb-1 font-medium">Group</label>
            
                               <DataSource   apiPath="components_data/groupid_option_list_2"  >
                                   {({ response }) => {
                                   const dropdownOptions = response?.map(x => ({
                                   label: x.groupnane || x.label, // adjust field
                                   value: x.groupId || x.value
                                   })) || [];
                                   return (
                                   <>
                                   <Dropdown
                                   name="groupid"
                                   value={groupId}
                                   onChange={(e) => setGroupId(e.value)}
                                   options={dropdownOptions}
                                   optionLabel="label"
                                   optionValue="value"
                                   filter   // 🔍 enables search box
                                   showClear
                                   placeholder="Select Group"
                                   className="w-500"
                                   />
                                   </>
                                   );
                                   }}
                               </DataSource>
                           

          </div>

          <div className="col-12 md:col-3">
            <label className="block mb-1 font-medium">Date From</label>
            <Calendar
              value={dateFrom}
              onChange={(e) => setDateFrom(e.value)}
              showIcon
              dateFormat="yy-mm-dd"
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-3">
            <label className="block mb-1 font-medium">Date To</label>
            <Calendar
              value={dateTo}
              onChange={(e) => setDateTo(e.value)}
              showIcon
              dateFormat="yy-mm-dd"
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-3 flex align-items-end">
            <Button
              label="Load Report"
              icon="pi pi-search"
              className="p-button-primary w-full"
              onClick={fetchData}
            />
          </div>
        </div>

        {loading ? (
          <div className="flex justify-content-center p-6">
            <ProgressSpinner />
          </div>
        ) : (
          <div className="mt-3">
            <DataTable
              value={records}
              paginator
              rows={10}
              scrollable
              scrollHeight="60vh"
              responsiveLayout="scroll"
              stripedRows
            >
              {columns.map((col) => (
                <Column
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  sortable
                  style={{ minWidth: "120px" }}
                />
              ))}
            </DataTable>
          </div>
        )}
      </Card>
    </div>
  );
}
